module.exports = __webpack_public_path__ + "static/img/icon-menu1-3.4ec0cef8.svg";